import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  public ApiUrl = "";
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.ApiUrl = baseUrl;
  }

  getDrugStatisticsReportVo(pharmacyId, facilityId, monthText): Observable<any> {
    return this.http.get<any>(this.ApiUrl + 'api/statistics/GetDrugStatisticsReportVo/' + pharmacyId + '/' + facilityId + '/' + monthText);
  }

  getDrugStatisticsMonthVos(pharmacyId, facilityId): Observable<any[]> {
    return this.http.get<any[]>(this.ApiUrl + 'api/statistics/GetDrugStatisticsMonthVos/' + pharmacyId + '/' + facilityId);
  }

  getStatisticsRxReportMonths(): Observable<string[]> {
    return this.http.get<string[]>(this.ApiUrl + 'api/statistics/GetStatisticsRxReportMonths');
  }

  getDrugStatisticsHomes(): Observable<any[]> {
    return this.http.get<any[]>(this.ApiUrl + 'api/statistics/GetDrugStatisticsHomes');
  }

  getDrugStatisticsFromRx(
    pharmacyId: number,
    facilityId: number,
    reportYear: number,
    reportQuarter: number,
    wardIds?: number[],
    groupIds?: number[]
  ): Observable<any> {
    var url = this.ApiUrl
      + 'api/statistics/GetDrugStatisticsFromRx/'
      + pharmacyId + '/' + facilityId + '/' + reportYear + '/' + reportQuarter;
    var body = {
      wardIds: wardIds && wardIds.length > 0 ? wardIds : [],
      groupIds: groupIds && groupIds.length > 0 ? groupIds : []
    };
    return this.http.post<any>(url, body);
  }

}
